import { graphql } from "@opensea/graphql"

export const useCreateCalendarEventFragment = graphql(`
  fragment useCreateCalendarEvent on DropStage {
    label
    startTime
    endTime
  }
`)
